import classnames from 'classnames';
import type { FC, HTMLAttributes } from 'react';

import styles from './tfooter.module.scss';

export type TFooterProps = HTMLAttributes<HTMLTableSectionElement> & {
  className?: string;
};

export const TFooter: FC<TFooterProps> = ({ className, children, ...props }) => (
  <tfoot className={classnames(styles.root, className)} {...props}>
    {children}
  </tfoot>
);
